// extracted by mini-css-extract-plugin
export default {"sidebarToggleButton":"ListSidebar-module__sidebarToggleButton--IfwKb","sidebarHeading":"ListSidebar-module__sidebarHeading--HvbDh"};